import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';

import MoneyUnit決算期TableHeader from '@/components/moneyUnit決算期TableHeader/MoneyUnit決算期TableHeader.vue';
import PlbscfTableRow from '@/components/plbscfTableRow/PlbscfTableRow.vue';
import YearValueCell from '@/components/yearValueCell/YearValueCell.vue';
import C勘定科目ListEditItemButtons from '@/components/勘定科目/listEdit/button/item/勘定科目ListEditItemButtons.vue';

import PlbscfKeystrokeInputableTextMixin, {
  PlbscfInputableTextId,
} from '@/entries/user/mixins/PlbscfKeystrokeInputableTextMixin';
import PlbscfKeystrokeResetMixin from '@/entries/user/mixins/PlbscfKeystrokeResetMixin';
import Plbscf要約表示Mixin from '@/entries/user/mixins/Plbscf要約表示Mixin';

import { PlbscfListItem, PlbscfTypeList } from '@/classes/service/AbstractPlbscfService';
import { PlbscfType } from '@/master/Plbscf';
import 決算期Utility from '@/classes/common/決算期Utility';

export default mixins(PlbscfKeystrokeInputableTextMixin, Plbscf要約表示Mixin, PlbscfKeystrokeResetMixin).extend({
  name: 'PlbscfTable',

  components: {
    MoneyUnit決算期TableHeader,
    C勘定科目ListEditItemButtons,
    YearValueCell,
    PlbscfTableRow,
  },

  props: {
    plbscfTypeList: {
      type: Object as PropType<PlbscfTypeList>,
      required: true,
    },
    enabled要約表示: {
      type: Boolean,
      default: false,
    },
    isCF計算書: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    plbscfTypeListItems(): PlbscfListItem[] {
      if (!this.enabled要約表示) return this.plbscfTypeList.list;
      return this.filteredPlbscfListItems(this.plbscfTypeList.list);
    },
    categoryExists(): boolean {
      const foundCategoryRow = this.plbscfTypeList.list.find((row) => row.config.label.category !== undefined);
      return foundCategoryRow !== undefined;
    },
    colspan(): number {
      return this.categoryExists ? 4 : 3;
    },
    isCF計算式(): boolean {
      return this.plbscfTypeList.type === PlbscfType.CF計算書_計算式;
    },
    isReadonly(): boolean {
      return [PlbscfType.CF計算書_計算式, PlbscfType.変動損益, PlbscfType.運転資金, PlbscfType.FCF].includes(
        this.plbscfTypeList.type
      );
    },
    map(): PlbscfInputableTextId[][] {
      if (this.isReadonly) return [];
      return this.createMap(this.plbscfTypeListItems);
    },
    get計画0期Year(): number {
      return 決算期Utility.get計画0期の決算年(true);
    },
  },

  watch: {
    keystrokeResetCount: {
      handler(): void {
        this.setFirstId();
      },
      immediate: true,
    },
  },
});
